import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';

export async function updatePaygSetting(
  subscriptionApiKey: string,
  paygEnabled: boolean,
  auth: Authentication,
): Promise<void> {
  try {
    await HttpClient.put(
      '/subscription/settings/payg',
      { payg_enabled: paygEnabled },
      auth.token,
      {
        'x-api-key': subscriptionApiKey,
      },
    );
  } catch (e) {
    console.error('updatePaygSetting error:', e);
    throw new UpdatePaygSettingFailure((e as Error)?.message || 'Unknown error');
  }
}

export class UpdatePaygSettingFailure extends Failure {
  constructor(message = 'Unknown error', code = 'update-payg-setting-failure') {
    super(message, code);
  }
}
